import React from 'react';

export const MoreEventsSection = ({
    shouldShowMoreEventsFromThisOrganizer,
    isEventActive,
}: {
    shouldShowMoreEventsFromThisOrganizer: boolean;
    isEventActive: boolean;
}) => {
    return (
        <>
            {shouldShowMoreEventsFromThisOrganizer && isEventActive && (
                <div id="listings-root__more-events-from-this-organizer"></div>
            )}
            {isEventActive && (
                <div id="listings-root__collections-related-to-this-event"></div>
            )}
        </>
    );
};
